import { Standard } from '@getvim/vim-connect';
import {
  encounterA,
  encounterB,
  encounterC,
  encounterD,
  encounterE,
  nonEditableAssessment,
  encounterWithBasicInfo,
} from '../encounters';

export const predefinedPayloads: Record<string, Standard.Events.EncounterStartPayload> = {
  'Minnie Mouse - Encounter A': encounterA,
  'Steven Vazquez - Encounter B': encounterB,
  'Natasha Davies - Encounter C': encounterC,
  'Patricia Bell - Encounter d': encounterD,
  'Tony Stark - Encounter e': encounterE,
  'Assessment not editable': nonEditableAssessment,
  'Minnie Mouse - Encounter With Basic Info': encounterWithBasicInfo,
};
